import React, { useState, useEffect} from 'react';
import './CompetitionRoundRobinDraw.css'

import Select from 'react-select';

import moment from 'moment';

import useAxios from '../../useAxios';

const CompetitionRoundRobinDraw = ({competition, readonly, logout}) => {
  const [roundRobin, setRoundRobin] = useState(null);
  const [tables, setTables] = useState(null);
  const [axios] = useAxios(true, logout);
  const [disableDraw, setDisableDraw] = useState(false);

  useEffect(() => {
    getRoundRobin();
    if (readonly === false)
    {
      axios.get("tables", setTables);
    }
  }, []);

  const getRoundRobin = () => {
    if (readonly)
    {
      axios.get("public/competition/roundrobin/" + competition.id, setRoundRobin);
    }
    else
    {
      axios.get("competitionroundrobin/" + competition.id, setRoundRobin);
    }
  };

  const handleTableChange = (table, match) => {
    match.table = table;
    axios.post("match/" + match.id, match, getRoundRobin)
  }
  
  const handleDraw = () => {
    setDisableDraw(true);
    axios.post("competitionroundrobin/" + competition.id + "/draw", {}, (response) => window.location.reload())
  };

  const handleStart = () => {
    axios.post("competition/" + competition.id + "/start", {}, (response) => window.location.reload())
  };

  const handleEnd = () => {
    axios.post("competition/" + competition.id + "/end", {}, (response) => window.location.reload())
  };

  const handleGeneratePin = (match) => {
    axios.post("match/" + match.id + "/generate-pin", {}, (response) => {
      const formattedDateTime = match.dateTime ? moment(match.dateTime).format("DD MMM yyyy HH:mm") : "TBD";
      const siteUrl = window.location.origin;
      const matchLoginUrl = `${siteUrl}/login/match/${match.id}`;
      
      const shareMessage = `Your match is booked for ${formattedDateTime} on ${match.table ? match.table.name : 'TBD'}. Please use the scoreboard here ${matchLoginUrl} with PIN ${response.pin}.`;
      
      // Use native Web Share API if available (mobile devices)
      if (navigator.share) {
        navigator.share({
          title: 'Match Details',
          text: shareMessage
        }).catch((error) => {
          // Fallback to clipboard if share fails
          fallbackShare(shareMessage);
        });
      } else {
        // Fallback for desktop browsers
        fallbackShare(shareMessage);
      }
      
      getRoundRobin(); // Refresh to show the PIN
    });
  };

  const fallbackShare = (message) => {
    // Try to copy to clipboard
    if (navigator.clipboard) {
      navigator.clipboard.writeText(message).then(() => {
        alert('Match details copied to clipboard!');
      }).catch(() => {
        // Final fallback - show message in alert
        alert(`Share this message:\n\n${message}`);
      });
    } else {
      // Final fallback - show message in alert
      alert(`Share this message:\n\n${message}`);
    }
  };

  const canGeneratePin = (match) => {
    return match && match.status !== 2;
  };

  const group = (xs, key) => {
    return Object.values(xs.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {}));
  };

  const getHandicapForGameType = (player, gameTypeId) => {
    if (!player || !gameTypeId) {
      return 0;
    }
    const handicapEntry = (player.handicaps || []).find(h => h.gameTypeId === gameTypeId);
    return handicapEntry?.value ?? 0;
  };

  const getMatchDescription = (gameNumber, side) => {
    let game = null;

    for (let i = 0; i < roundRobin.rounds.length && game === null; i++)
    {
      var g = roundRobin.rounds[i].matches.filter(x => x.gameNumber === gameNumber);
      if (g.length > 0)
      {
        game = g[0];
      }
    }

    if (game != null)
    {
      var match = game[side].match;
      if (match != null && match.status === 2)
      {
        return match.home.winner ? match.home.player.name : match.away.player.name;
      }

      return "Winner of Match " + game[side].gameNumber;
    }

    return "something went wrong";
  } 

  if (roundRobin === null)
  {
    return <div>Loading...</div>
  }

  // Filter tables by competition game type
  const availableTables = (tables || []).filter((t) => {
    // If competition has a game type, only show tables with matching game type
    if (roundRobin?.gameType?.id) {
      return t.gameType?.id === roundRobin.gameType.id;
    }
    return true;
  });

  return (
    <div>
      {
        readonly === false && competition.status === 0 ?
        <button onClick={handleDraw} disabled={disableDraw}>{roundRobin.rounds.length > 0 ? "Re-" : ""}Draw</button> :
        null
      }
      {
        readonly === false && competition.status === 0 ?
        <button onClick={handleStart}>Start</button> :
        readonly === false && competition.status === 1 ?
        <button onClick={handleEnd}>End</button> :
        null
      }
      <br />
      <br />
      { roundRobin.tables.map(table => { return (
        <div className="competition-roundrobin-table">
          <h2>Group {table[0].group}</h2>
          <table>
            <thead>
              <tr>
                <td style={{backgroundColor: "#f4f4f4", borderTop: "none", borderLeft: "none"}}></td>
                <td>Played</td>
                <td>Won</td>
                <td>Lost</td>
                <td>Draw</td>
                <td>Frames</td>
                <td>Points</td>
              </tr>
            </thead>
            <tbody>
              {
                table.sort((a,b) => b.points - a.points).map((row) => {
                  return (<tr>
                    <th>{row.player.name}</th>
                    <td>{row.played}</td>
                    <td>{row.won}</td>
                    <td>{row.lost}</td>
                    <td>{row.draw}</td>
                    <td>{row.frames}</td>
                    <td>{row.points}</td>
                  </tr>);
                })
              }
            </tbody>
          </table>
        </div>
      )})
      }
      { 
        group(roundRobin.rounds.sort((a, b) => a.roundNumber - b.roundNumber), 'roundNumber').map((group, roundNumber) => {
            return (<div key={group.id}>
              <h2>Round {roundNumber + 1} - Race to {roundRobin.raceTo}</h2>
              <table>
                <thead>
                  <tr>
                    <th>Group</th>
                    <th>Game</th>
                    <th>Home</th>
                    <th>Score</th>
                    <th></th>
                    <th>Score</th>
                    <th>Away</th>
                    <th>Table</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                { 
                  group.map(round => { return round.matches.map((m) => {
                    
                    return (<tr key={m.id} className={m.match.status === 2 ? "finished" : ""}>
                      <td>Group {round.group}</td>
                      <td>{m.gameNumber}</td>
                      <td>{m.match.home?.player === null ? "Bye" : m.match.home?.player?.name + " (" + m.match.home?.player?.handicap + ")"}</td>
                      <td>{m.match.home?.score}</td>
                      <td>v</td>
                      <td>{m.match.away?.score}</td>
                      <td>{m.match.away?.player === null ? "Bye" : "(" + m.match.away?.player?.handicap + ") " + m.match.away?.player?.name}</td>
                      <td>
                        {readonly === false && m.match.status !== 2 ? <Select
                          value={m.match.table}
                          onChange={(option) => handleTableChange(option, m.match)}
                          options={availableTables}
                          isClearable={true}
                          placeholder="Select..."
                          getOptionValue={(option) => option.id}  // Specify the property used for value
                          getOptionLabel={(option) => option.name}  // Specify the property used for label
                          isSearchable={false}
                        /> : m.match?.table?.name }
                      </td>
                      <td>
                        {m.match.pin && (
                          <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>{m.match.pin}</span>
                        )}
                        {!readonly && canGeneratePin(m.match) && (
                          <button 
                            onClick={() => handleGeneratePin(m.match)}
                            className="edit-button"
                            style={{ marginLeft: m.match.pin ? '10px' : '0' }}
                          >
                            Share
                          </button>
                        )}
                      </td>
                    </tr>);
                  }) })
                }
                </tbody>
              </table>
            </div>);
        })
      }
    </div>
  );
};

export default CompetitionRoundRobinDraw;
